import * as React from 'react'
import { connect } from 'react-redux'
import Breadcrumbs from '../Breadcrumbs.component'

import { Table, CustomInput } from 'reactstrap'

import { RootState } from '../../store/rootReducer'
import { LocationJobPosition } from '../../lib/interfaces/JobPosition.interface'

import * as applicationsActions from '../../store/applications/actions'

const get = require('lodash/get')
const map = require('lodash/map')

export interface JobPositionsPageProps {
  isFetching: boolean
  locationJobPositions: LocationJobPosition[]
  fetchJobLocationPositionsList: (next?: () => void) => void
  updateLocationJobPositionOpen: (locationJobPositionId: number, open: boolean, next?: () => void) => void
}

class JobPositionsPage extends React.PureComponent<JobPositionsPageProps> {
  componentDidMount() {
    this.props.fetchJobLocationPositionsList()
  }

  renderLoadingCell() {
    return (
      <tr>
        <td colSpan={8} className="text-center">
          Loading...
        </td>
      </tr>
    )
  }

  render() {
    const { isFetching, locationJobPositions, updateLocationJobPositionOpen } = this.props

    return (
      <div>
        <Breadcrumbs breadcrumbs={[
          { name: 'Dashboard', link: '/dashboard' },
          { name: 'Positions', active: true }
        ]} />

        <div className="page">
          <div className="d-flex align-items-center mb-2">
            <h5 className="title mb-0">Positions</h5>
          </div>

          <Table hover className="table table-striped">
            <thead>
              <tr>
                <th>Enabled</th>
                <th>Position Title</th>
                <th>Location</th>
              </tr>
            </thead>
            <tbody>
              {isFetching && this.renderLoadingCell()}
              {!isFetching && map(locationJobPositions, locationJobPosition => (
                <tr key={locationJobPosition.id} style={{ cursor: 'pointer' }}>
                  <td><CustomInput
                    bsSize="lg"
                    type="checkbox"
                    className="d-flex"
                    id={locationJobPosition.id}
                    checked={locationJobPosition.enabled}
                    onChange={e => updateLocationJobPositionOpen(locationJobPosition.id, e.target.checked)}
                  /></td>
                  <td>{get(locationJobPosition, 'jobPositionName', 0)}</td>
                  <td>{get(locationJobPosition, 'location.name')}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (rootState: RootState)  => ({
  isFetching: rootState.applications.isFetching,
  locationJobPositions: rootState.applications.locationJobPositions
})

const mapDispatchToProps = dispatch => ({
  fetchJobLocationPositionsList: (next?: () => void) => dispatch(applicationsActions.fetchJobLocationPositionsList(next)),
  updateLocationJobPositionOpen: (locationJobPositionId: number, open: boolean, next?: () => void) => dispatch(applicationsActions.updateLocationJobPositionOpen(locationJobPositionId, open, next))
})

export default connect(mapStateToProps, mapDispatchToProps)(JobPositionsPage)



// WEBPACK FOOTER //
// ./src/routes/applications/JobPositions.page.tsx